// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3U7Jp","title":"ClientInsurance_title__3GoLi","itemText":"ClientInsurance_itemText__1nvoS"};